export function setIsSavingContactForm(state, payload) {
  state.isSavingContactForm = payload;
}
